export default __webpack_public_path__ + "static/media/it930-a033-1.31135246.jpg";